import { useBreakpoint } from '@eppendorf/vnls-react-components-preview';
import { ReactElement } from 'react';

import { Overview } from '$components/overview-box/overview-box';

import { ReportHubList } from './report-hub-list';

export function ReportHubOverview(): ReactElement {
  const isMaxMd = useBreakpoint({ max: 'md' });

  return (
    <Overview className={`box--mobile-fullscreen ${isMaxMd ? 'box--no-shadow' : ''}`}>
      <ReportHubList />
    </Overview>
  );
}
